import * as React from 'react';

import { Translate } from '@decorators';

import {
	EBrandFileName,
	EBrandImage,
} from '../../enums';
import { IBrandPageProps } from '../../types';
import { BrandBaseElementsScreen } from '../BrandBaseElementsScreen';

@Translate('common.containers.Brand.components.BrandIllustrationsScreen')
export class BrandIllustrationsScreen extends React.Component<IBrandPageProps> {

	render() {
		const {
			isMobile,
			brand: {
				fileSizes: {
					illustrations: fileSize,
				},
			},
			urls: {
				brandDownload,
				imagePath,
			},
			onDownloadButtonClick,
		} = this.props;

		const images = [
			EBrandImage.ILLUSTRATION_SAD,
			EBrandImage.ILLUSTRATION_DANCE,
			EBrandImage.ILLUSTRATION_DOGMAN,
			EBrandImage.ILLUSTRATION_BOOM,
			EBrandImage.ILLUSTRATION_SEARCH,
		].map((image) => `${imagePath}/illustrations/${image}.svg`);

		return (
			<BrandBaseElementsScreen
				isMobile={isMobile}
				downloadFileSize={fileSize}
				downloadLinkUrl={`${brandDownload}/${EBrandFileName.ILLUSTRATIONS}.zip`}
				downloadTitle={this.t('downloadAll')}
				images={images}
				onDownloadButtonClick={onDownloadButtonClick}
			/>
		);
	}

}
